<template>
  <div class="wrapper">
    <van-nav-bar left-text="返回" left-arrow @click-left="$router.go(-1)">
      <span slot="right">
        <!-- <i class="iconfont icon-sousuo1"></i> -->
      </span>
    </van-nav-bar>
    <div class="title">{{$route.query.name}}</div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      class="model-list"
    >
      <ul class="model-wrapper">
        <li
          v-for="(item, index) in list"
          class="model-item"
          :key="index"
          @click="BrowseModel(item)"
        >
          <img :src="item.thumbnail | thumbnail(340,340) ">
          <div class="model-name">{{item.name}}</div>
        </li>
      </ul>
    </van-list>
  </div>
</template>

<script>
import { NavBar, List, Toast } from "vant";
import { modelList } from "@/api/modelReq";

export default {
  components: {
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Toast.name]: Toast
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      error: false
    };
  },

  methods: {
    onLoad() {
      this.list = this.$route.query.result;
      this.finished = !this.finished;
      this.loading = false;
    },
    BrowseModel(item) {
      if (item.isAlbum) {
        // type : vertical为竖向，transverse为横向
        this.$store.dispatch("ChangePreviewShow", {
          item,
          show: true,
          type: "vertical"
        });
        return;
      }
      if (!item.modelId) {
        Toast("没有上传模型");
        return;
      }
      this.$router.push({
        path: "/model-view",
        query: {
          modelId: item.modelId,
          id: item.id
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.wrapper {
  /deep/.van-icon {
    color: rgba(65, 65, 65, 1);
  }
  /deep/.van-nav-bar__text {
    font-weight: 400;
    color: rgba(65, 65, 65, 1);
  }
  .title {
    padding: 0 14px;
    margin-top: 20px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
    font-size: 18px;
  }
  .model-list {
    margin-top: 20px;
    padding: 0 14px;
    .model-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      .model-item {
        width: 49%;
        height: auto;
        margin-bottom: 13px;
        text-align: center;
        background: rgba(255, 255, 255, 1);
        box-shadow: 2px 3px 6px 0px rgba(66, 83, 103, 0.05);
        border-radius: 2px;
        img {
          width: 100%;
          height: 45.34vw;
          vertical-align: middle;
        }
        .model-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          //   background: #fff;
          text-align: left;
          //   margin-top: 12px;
          color: rgba(51, 51, 51, 1);
          font-size: 14px;
          font-weight: 400;
          padding: 8% 0 7% 9%;
          box-sizing: border-box;
        }
        // width: 48%;
        // // margin-right: 13px;
        // text-align: center;
        // margin-bottom: 20px;
        // img{
        //   width: 100%;
        //   box-shadow:1px 6px 21px 0px rgba(66,83,103,0.08);
        //   border-radius:3px;
        // }
        // .model-name{
        //    overflow: hidden;
        //    text-overflow:ellipsis;
        //    white-space: nowrap;
        //    width: 85%;
        //    text-align: left;
        //    font-size:14px;
        //    font-weight:400;
        //    color:rgba(51,51,51,1);
        //    margin-top: 12px;
        // }
      }
    }
  }
}
</style>
